/**
 * @generated SignedSource<<89ded10d981164c873195c6c59e642e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationsTab_brand$data = {
  readonly appsflyerDevKey: string | null;
  readonly emarsysApiClientId: string | null;
  readonly gorgiasId: string | null;
  readonly hasEmarsysApiClientSecret: boolean;
  readonly hasKlaviyoApiToken: boolean;
  readonly hasKustomerApiToken: boolean;
  readonly hasOmetriaApiToken: boolean;
  readonly hasRechargeApiToken: boolean;
  readonly kinnApiToken: string;
  readonly " $fragmentSpreads": FragmentRefs<"CookiesCard_brand" | "DiscourseCard_brand" | "SlackCard_brand" | "SocialLoginCard_brand" | "useBrandUpdateMutation_brand">;
  readonly " $fragmentType": "IntegrationsTab_brand";
};
export type IntegrationsTab_brand$key = {
  readonly " $data"?: IntegrationsTab_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationsTab_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationsTab_brand",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBrandUpdateMutation_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CookiesCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiscourseCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SlackCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SocialLoginCard_brand"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gorgiasId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasKlaviyoApiToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kinnApiToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasKustomerApiToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasOmetriaApiToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emarsysApiClientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasEmarsysApiClientSecret",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasRechargeApiToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appsflyerDevKey",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "55865239aac5feea06e51af135cf2290";

export default node;
